import { CollectionClassName } from './models/collection';

export const collectionClassNameLabels: Record<CollectionClassName, string> = {
  Base: 'Base',
  BeneD: 'Disegno',
  BeneF: 'Foto',
  BeneMI: 'Matrice Incisa',
  BeneOA: 'Oggetto Artistico',
  BeneS: 'Stampa',
  Collezione: 'Collezione',
  DocumentoArc: 'Doc. Archivistico',
  DocumentoBib: 'Doc. Bibliografico',
  OggettoCollezione: 'Oggetto Collezione',
};

export const iterableCollectionClassNameLabels = Object.keys(collectionClassNameLabels)
  .filter((key): key is CollectionClassName => !!key)
  .map((key) => ({ label: collectionClassNameLabels[key], value: key }));
